import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 6,
  class: "mx-2 my-5"
}
const _hoisted_2 = ["colspan"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "item-label" }, "Objective", -1)
const _hoisted_4 = { class: "item-value" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { class: "item-label" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "item-value-small" }
const _hoisted_9 = { class: "item-label" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = {
  key: 0,
  class: "item-label"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = { key: 1 }
const _hoisted_16 = {
  key: 2,
  class: "d-block mt-2"
}
const _hoisted_17 = {
  key: 3,
  class: "d-block mt-2"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("hr", { class: "my-4" }, null, -1)
const _hoisted_19 = {
  key: 0,
  tool: ""
}
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { key: 2 }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("h4", { class: "text-red" }, "Note: Beacuse of PII information contained in tab title and contents it will not be stored in database.", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("hr", { class: "my-4" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("strong", null, "Class Objective", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("strong", null, "Is Active", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("strong", null, "Similarity Score", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("strong", null, [
  /*#__PURE__*/_createTextVNode("Title "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red" }, "(PII's Removed)")
], -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("strong", null, [
  /*#__PURE__*/_createTextVNode("Content "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red" }, "(PII's Removed)")
], -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("hr", { class: "my-4" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar_items = _resolveComponent("v-toolbar-items")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_SessionImageViewer = _resolveComponent("SessionImageViewer")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_pagination = _resolveComponent("v-pagination")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_textarea = _resolveComponent("v-textarea")!

  return (_openBlock(), _createBlock(_component_v_container, { style: {"max-width":"100%"} }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { class: "text-center" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_text_field, {
            class: "mx-4 my-2",
            "data-testId": "classSessionId",
            modelValue: _ctx.classSessionId,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.classSessionId) = $event)),
            modelModifiers: { trim: true },
            label: "Class Session id#",
            variant: "underlined",
            style: {"max-width":"250px"},
            disabled: _ctx.sessionIdSet
          }, null, 8, ["modelValue", "disabled"]),
          (_ctx.sessionIdSet && _ctx.studentsLoaded && !_ctx.studentsListLoading)
            ? (_openBlock(), _createBlock(_component_v_select, {
                key: 0,
                "data-testId": "studentId",
                modelValue: _ctx.studentId,
                "onUpdate:modelValue": [
                  _cache[1] || (_cache[1] = ($event: any) => ((_ctx.studentId) = $event)),
                  _cache[2] || (_cache[2] = ($event: any) => ($options.loadData()))
                ],
                items: _ctx.studentsList,
                width: "150",
                label: "Select Student id#",
                variant: "underlined",
                class: "mx-4 my-2",
                style: {"max-width":"200px"}
              }, null, 8, ["modelValue", "items"]))
            : _createCommentVNode("", true),
          (_ctx.studentsListLoading)
            ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                key: 1,
                indeterminate: "",
                color: "primary",
                class: "mx-2 my-4"
              }))
            : _createCommentVNode("", true),
          (!_ctx.studentsLoaded && !_ctx.studentsListLoading && !_ctx.classStatsloading)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 2,
                color: "primary",
                class: "mx-4 my-4",
                onClick: _cache[3] || (_cache[3] = ($event: any) => ($options.loadStudents()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" LOAD STUDENTS")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.sessionIdSet && _ctx.studentsLoaded)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 3,
                color: "primary",
                class: "mx-4 my-4",
                onClick: _cache[4] || (_cache[4] = ($event: any) => ($options.resetUI()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" RESET ")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_ctx.classStatsloading)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 4,
                color: "primary",
                class: "mx-4 my-4",
                onClick: _cache[5] || (_cache[5] = ($event: any) => ($options.getClassAccuracy()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" GET CLASS ACCURACY")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.classStatsloading)
            ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                key: 5,
                class: "mx-4 my-4 title-element",
                indeterminate: "",
                color: "primary"
              }))
            : _createCommentVNode("", true),
          (_ctx.classStatsloading)
            ? (_openBlock(), _createElementBlock("span", _hoisted_1, "Loading class statistics"))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (_ctx.sessionIdSet && _ctx.studentId !== '')
        ? (_openBlock(), _createBlock(_component_v_data_table, {
            key: 0,
            "data-testId": "sessionsData",
            headers: _ctx.headers,
            items: _ctx.tableData,
            "item-value": "id",
            class: "elevation-1 table-striped",
            "sort-by": [{ key: 'time', order: 'asc' }],
            loading: _ctx.tableDataLoading,
            "loading-text": "Loading... Please wait",
            page: _ctx.page,
            "items-per-page": _ctx.itemsPerPage,
            "hide-default-footer": "",
            "show-expand": "",
            expanded: _ctx.expanded
          }, {
            top: _withCtx(() => [
              _createVNode(_component_v_toolbar, { flat: "" }, {
                default: _withCtx(() => [
                  (_ctx.sessionIdSet && _ctx.studentsLoaded && !_ctx.tableDataLoading)
                    ? (_openBlock(), _createBlock(_component_v_toolbar_title, { key: 0 }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.studentStats.accuracy) + "% accurate from " + _toDisplayString(_ctx.studentStats.totalRecords - _ctx.studentStats.notReviewed) + " out of " + _toDisplayString(_ctx.tableData ? _ctx.tableData.length : 0) + " records ", 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_toolbar_title, {
                    style: {"text-align":"right"},
                    class: "mx-3"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Filter: ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_toolbar_items, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select, {
                        "data-testId": "requestType",
                        modelValue: _ctx.filter.requestType,
                        "onUpdate:modelValue": [
                          _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filter.requestType) = $event)),
                          _cache[7] || (_cache[7] = ($event: any) => ($options.filterResults()))
                        ],
                        items: _ctx.requestTypes,
                        "item-title": "text",
                        "item-value": "value",
                        width: "150",
                        label: "Request Type",
                        variant: "underlined",
                        class: "mx-2 my-2",
                        style: {"width":"150px"}
                      }, null, 8, ["modelValue", "items"]),
                      _createVNode(_component_v_select, {
                        "data-testId": "aiClassification",
                        modelValue: _ctx.filter.aiClassification,
                        "onUpdate:modelValue": [
                          _cache[8] || (_cache[8] = ($event: any) => ((_ctx.filter.aiClassification) = $event)),
                          _cache[9] || (_cache[9] = ($event: any) => ($options.filterResults()))
                        ],
                        items: _ctx.aiClassificationsList,
                        "item-title": "text",
                        "item-value": "value",
                        width: "150",
                        label: "AI Classification",
                        variant: "underlined",
                        class: "mx-2 my-2",
                        style: {"width":"150px"}
                      }, null, 8, ["modelValue", "items"]),
                      _createVNode(_component_v_select, {
                        "data-testId": "humanClassification",
                        modelValue: _ctx.filter.humanClassification,
                        "onUpdate:modelValue": [
                          _cache[10] || (_cache[10] = ($event: any) => ((_ctx.filter.humanClassification) = $event)),
                          _cache[11] || (_cache[11] = ($event: any) => ($options.filterResults()))
                        ],
                        items: _ctx.humanClassificationsList,
                        "item-title": "text",
                        "item-value": "value",
                        width: "150",
                        label: "Human Classification",
                        variant: "underlined",
                        class: "mx-2 my-2",
                        style: {"width":"150px"}
                      }, null, 8, ["modelValue", "items"]),
                      _createVNode(_component_v_select, {
                        "data-testId": "captureModesFilter",
                        modelValue: _ctx.filter.captureMode,
                        "onUpdate:modelValue": [
                          _cache[12] || (_cache[12] = ($event: any) => ((_ctx.filter.captureMode) = $event)),
                          _cache[13] || (_cache[13] = ($event: any) => ($options.filterResults()))
                        ],
                        items: _ctx.captureModes,
                        "item-title": "text",
                        "item-value": "value",
                        width: "150",
                        label: "Capture Mode",
                        variant: "underlined",
                        class: "mx-2 my-2",
                        style: {"width":"150px"}
                      }, null, 8, ["modelValue", "items"]),
                      (_ctx.filter.requestType !== '' || _ctx.filter.aiClassification !== '' || _ctx.filter.humanClassification !== '' || _ctx.filter.captureMode !== '')
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            color: "primary",
                            class: "mx-2",
                            onClick: _cache[14] || (_cache[14] = ($event: any) => ($options.clearSearch())),
                            variant: "text"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" CLEAR SEARCH ")
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            "expanded-row": _withCtx(({ columns, item }) => [
              _createElementVNode("td", {
                colspan: columns.length,
                style: {"padding":"20px"}
              }, [
                _createVNode(_component_v_container, { class: "bg-grey-lighten-5" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "2" }, {
                          default: _withCtx(() => [
                            _hoisted_3,
                            _createElementVNode("span", _hoisted_4, _toDisplayString(item.objectiveText), 1),
                            _hoisted_5
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_col, { cols: "5" }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_6, [
                              _createTextVNode(" Tabs "),
                              (item.avgTabSimilarity)
                                ? (_openBlock(), _createBlock(_component_v_chip, {
                                    key: 0,
                                    color: $options.getColorCodeForSimilarityValue(item.avgTabSimilarity),
                                    variant: "outlined",
                                    size: "small",
                                    class: "mx-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.avgTabSimilarity) + " ", 1),
                                      _createVNode(_component_v_tooltip, {
                                        activator: "parent",
                                        location: "end"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Average Tab Similarity Score (" + _toDisplayString($options.displayNameForClassification($options.getClassificationBasedOnSimilarityScore(item.avgTabSimilarity))) + ")", 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1032, ["color"]))
                                : _createCommentVNode("", true)
                            ]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.tabsInfo, (tab) => {
                              return (_openBlock(), _createElementBlock("ul", {
                                key: tab,
                                class: "my-2"
                              }, [
                                _createElementVNode("li", null, [
                                  _createVNode(_component_v_icon, {
                                    icon: "mdi-message-draw",
                                    color: tab.hasClassification ? 'green' : 'grey',
                                    onClick: ($event: any) => ($options.openTabClassificationDialog(tab, item))
                                  }, null, 8, ["color", "onClick"]),
                                  _createTextVNode("    "),
                                  _createElementVNode("span", {
                                    onClick: ($event: any) => ($options.showOpenLinkConfirmDialog(tab.url)),
                                    class: "docker-log-link text-primary",
                                    style: {"text-decoration":"underline","cursor":"pointer"}
                                  }, _toDisplayString(tab.cleanTitle), 9, _hoisted_7),
                                  (tab.tabSimilarity)
                                    ? (_openBlock(), _createBlock(_component_v_chip, {
                                        key: 0,
                                        color: $options.getColorCodeForSimilarityValue(tab.tabSimilarity),
                                        variant: "outlined",
                                        size: "small",
                                        class: "mx-2",
                                        density: "compact"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(tab.tabSimilarity) + " ", 1),
                                          _createVNode(_component_v_tooltip, {
                                            activator: "parent",
                                            location: "end"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode("Tab Similarity Score (" + _toDisplayString($options.displayNameForClassification($options.getClassificationBasedOnSimilarityScore(tab.tabSimilarity))) + ")", 1)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1032, ["color"]))
                                    : _createCommentVNode("", true),
                                  (tab.isActive)
                                    ? (_openBlock(), _createBlock(_component_v_chip, {
                                        key: 1,
                                        color: "primary",
                                        size: "x-small"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Active")
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  (tab.usedDataGathering === true)
                                    ? (_openBlock(), _createBlock(_component_v_chip, {
                                        key: 2,
                                        color: "red",
                                        size: "x-small"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Used Data Gathering")
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_8, _toDisplayString($options.getDomain(tab.url)), 1)
                                ])
                              ]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_col, {
                          cols: "5",
                          style: {"position":"relative"}
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_9, [
                              _createTextVNode(" OCR Text "),
                              (item.textSimilarity)
                                ? (_openBlock(), _createBlock(_component_v_chip, {
                                    key: 0,
                                    color: $options.getColorCodeForSimilarityValue(item.textSimilarity),
                                    variant: "outlined",
                                    size: "small",
                                    class: "mx-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.textSimilarity) + " ", 1),
                                      _createVNode(_component_v_tooltip, {
                                        activator: "parent",
                                        location: "end"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Text Similarity Score (" + _toDisplayString($options.displayNameForClassification($options.getClassificationBasedOnSimilarityScore(item.textSimilarity))) + ")", 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1032, ["color"]))
                                : _createCommentVNode("", true)
                            ]),
                            _hoisted_10,
                            _createElementVNode("span", null, _toDisplayString(item.ocrText), 1),
                            _hoisted_11,
                            _hoisted_12,
                            (item.usedDataGathering)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_13, " Active Tab contents "))
                              : _createCommentVNode("", true),
                            _hoisted_14,
                            (item.usedDataGathering)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(item.activeTabText), 1))
                              : _createCommentVNode("", true),
                            (item.requestType === 'image' || item.usedDataGathering)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_16))
                              : _createCommentVNode("", true),
                            (item.requestType === 'image' || item.usedDataGathering)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                                  _createVNode(_component_SessionImageViewer, {
                                    path: item.path
                                  }, null, 8, ["path"])
                                ]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_v_icon, {
                              class: _normalizeClass(["deepLink", { highlighted: item.copied }]),
                              icon: "mdi-link",
                              onClick: ($event: any) => ($options.copyDeepLink($event, item)),
                              title: "Copy Direct Link"
                            }, null, 8, ["onClick", "class"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024),
                    _hoisted_18,
                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "3" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_select, {
                              items: _ctx.humanClassificationsList,
                              "item-title": "text",
                              "item-value": "value",
                              label: "Human Classification",
                              modelValue: item.humanClassification,
                              "onUpdate:modelValue": [($event: any) => ((item.humanClassification) = $event), ($event: any) => ($options.OnHumanClassificationUpdated(item))],
                              variant: "underlined",
                              class: "mx-2 my-2"
                            }, null, 8, ["items", "modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_col, { cols: "3" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_select, {
                              items: _ctx.confidenceItems,
                              "item-title": "text",
                              "item-value": "value",
                              label: "Confidence",
                              modelValue: item.confidence,
                              "onUpdate:modelValue": [($event: any) => ((item.confidence) = $event), ($event: any) => ($options.OnHumanClassificationUpdated(item))],
                              variant: "underlined",
                              class: "mx-2 my-2"
                            }, null, 8, ["items", "modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_col, { cols: "3" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              label: "Notes",
                              modelValue: item.notes,
                              "onUpdate:modelValue": ($event: any) => ((item.notes) = $event),
                              variant: "underlined",
                              "multi-line": "",
                              class: "capitalize mx-2 my-2",
                              onBlur: ($event: any) => ($options.OnHumanClassificationUpdated(item))
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_col, { cols: "2" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              label: "Reviewer",
                              disabled: true,
                              modelValue: item.reviewer,
                              "onUpdate:modelValue": ($event: any) => ((item.reviewer) = $event),
                              variant: "underlined",
                              class: "capitalize mx-2 my-2"
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ], 8, _hoisted_2)
            ]),
            [`item.time`]: _withCtx(({ item }) => [
              _createTextVNode(_toDisplayString($options.formatTime(item.time)), 1)
            ]),
            [`item.requestType`]: _withCtx(({ item }) => [
              _createTextVNode(_toDisplayString($options.displayNameForRequestType(item.requestType, item.usedDataGathering)), 1)
            ]),
            [`item.finalSimilarity`]: _withCtx(({ item }) => [
              (item.finalSimilarity)
                ? (_openBlock(), _createBlock(_component_v_chip, {
                    key: 0,
                    color: $options.getColorCodeForSimilarityValue(item.finalSimilarity),
                    variant: "tonal",
                    size: "small",
                    class: "mx-2"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.finalSimilarity) + " ", 1),
                      _createVNode(_component_v_tooltip, {
                        activator: "parent",
                        location: "end"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Final Similarity Score (" + _toDisplayString($options.displayNameForClassification($options.getClassificationBasedOnSimilarityScore(item.finalSimilarity))) + ")", 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["color"]))
                : _createCommentVNode("", true)
            ]),
            [`item.aiClassification`]: _withCtx(({ item }) => [
              _createTextVNode(_toDisplayString($options.displayNameForClassification(item.aiClassification)), 1)
            ]),
            [`item.humanClassification`]: _withCtx(({ item }) => [
              _createTextVNode(_toDisplayString($options.displayNameForClassification(item.humanClassification)), 1)
            ]),
            [`item.reviewed`]: _withCtx(({ item }) => [
              (item.hasReviews)
                ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                    _createVNode(_component_v_icon, {
                      icon: "mdi-message-draw",
                      color: "green"
                    }),
                    _createVNode(_component_v_tooltip, {
                      activator: "parent",
                      location: "bottom"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Reviewed")
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            [`item.accuracy`]: _withCtx(({ item }) => [
              (item.classificationMatched === undefined)
                ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                    (!item.humanClassification && item.aiClassification === _ctx.Classifications.POSSIBLY_OFF_TASK)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                          _createVNode(_component_v_icon, {
                            icon: "mdi-check-circle",
                            color: "orange-lighten-1"
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (item.classificationMatched === false)
                ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                    _createVNode(_component_v_icon, {
                      icon: "mdi-close-circle",
                      color: "red"
                    })
                  ]))
                : _createCommentVNode("", true),
              (item.classificationMatched === true)
                ? (_openBlock(), _createElementBlock("span", _hoisted_23, [
                    _createVNode(_component_v_icon, {
                      icon: "mdi-check-circle",
                      color: "green"
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            bottom: _withCtx(() => [
              _createVNode(_component_v_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { style: {"padding-top":"20px"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "9" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_pagination, {
                            modelValue: _ctx.page,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.page) = $event)),
                            length: $options.pageCount
                          }, null, 8, ["modelValue", "length"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: "3" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_select, {
                            items: _ctx.pagingOptions,
                            label: "Page Size",
                            modelValue: _ctx.itemsPerPage,
                            "onUpdate:modelValue": [
                              _cache[16] || (_cache[16] = ($event: any) => ((_ctx.itemsPerPage) = $event)),
                              _cache[17] || (_cache[17] = ($event: any) => ($options.paginationChanged()))
                            ],
                            class: "mx-2",
                            variant: "underlined"
                          }, null, 8, ["items", "modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 2
          }, 1032, ["headers", "items", "loading", "page", "items-per-page", "expanded"]))
        : _createCommentVNode("", true),
      _createVNode(_component_v_snackbar, {
        modelValue: $options.hasError,
        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (($options.hasError) = $event)),
        color: "red",
        location: "top",
        "multi-line": true
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.errorMessage) + " ", 1),
          _createVNode(_component_v_btn, {
            variant: "text",
            class: "mx-2",
            onClick: _cache[18] || (_cache[18] = ($event: any) => ($options.dismissError()))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Dismiss")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_dialog, {
        scrollable: "",
        width: "80%",
        style: {"max-height":"80%","min-height":"80%"},
        modelValue: _ctx.showAccuracyDialog,
        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.showAccuracyDialog) = $event))
      }, {
        default: _withCtx(({ isActive }) => [
          _createVNode(_component_v_card, {
            title: 'Class Accuracy (Session id# ' + _ctx.classSessionId + ')'
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_data_table, {
                    "data-testId": "accuracyReportData",
                    headers: _ctx.accuracyReportHeaders,
                    items: _ctx.accuracyReportTableData,
                    "item-value": "studentId",
                    class: "elevation-1 table-striped",
                    "sort-by": [{ key: 'accuracy', order: 'desc' }]
                  }, {
                    top: _withCtx(() => [
                      _createVNode(_component_v_toolbar, { flat: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_toolbar_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.classStats.accuracy) + "% accurate from " + _toDisplayString(_ctx.classStats.totalRecords - _ctx.classStats.notReviewed) + " out of " + _toDisplayString(_ctx.classStats.totalRecords) + " records from " + _toDisplayString(_ctx.accuracyReportTableData.length) + " students ", 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    [`item.studentId`]: _withCtx(({ item }) => [
                      _createElementVNode("a", {
                        class: "text-decoration-none",
                        href: "#",
                        onClick: ($event: any) => {
                                        isActive.value = false;
                                        $options.showStudentRecordsFromAccuracyReport(item.studentId);
                                    },
                        style: {"cursor":"pointer"}
                      }, [
                        _createElementVNode("strong", null, _toDisplayString(item.studentId), 1)
                      ], 8, _hoisted_24)
                    ]),
                    [`item.accuracy`]: _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(item.accuracy) + " %", 1)
                    ]),
                    _: 2
                  }, 1032, ["headers", "items"])
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_v_card_actions, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_btn, {
                    variant: "text",
                    onClick: ($event: any) => (isActive.value = false)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Close Dialog")
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["title"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_dialog, {
        scrollable: "",
        width: "80%",
        style: {"max-height":"80%","min-height":"80%"},
        modelValue: _ctx.showOpenLinkConfirmationDialog,
        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.showOpenLinkConfirmationDialog) = $event))
      }, {
        default: _withCtx(({ isActive }) => [
          _createVNode(_component_v_card, { title: 'Open Link Confirmation Dialog' }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createTextVNode(" Open Link : " + _toDisplayString(_ctx.currentClickedLink), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_actions, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_btn, {
                    variant: "text",
                    onClick: ($event: any) => {
                                $options.openCurrentLinkInNewWindow();
                                isActive.value = false;
                            },
                    color: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Open Link")
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_v_btn, {
                    variant: "text",
                    onClick: ($event: any) => (isActive.value = false)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Cancel")
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_dialog, {
        scrollable: "",
        width: "80%",
        style: {"max-height":"80%","min-height":"80%"},
        modelValue: _ctx.showTabClassificationDialog,
        "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.showTabClassificationDialog) = $event))
      }, {
        default: _withCtx(({ isActive }) => [
          _createVNode(_component_v_card, {
            title: _ctx.currentClickedTab.url
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _hoisted_25,
                  _hoisted_26,
                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "3" }, {
                        default: _withCtx(() => [
                          _hoisted_27,
                          _hoisted_28,
                          _createTextVNode(" " + _toDisplayString(_ctx.currentClickedTab.objectiveText) + " ", 1),
                          _hoisted_29,
                          _hoisted_30,
                          _hoisted_31,
                          _hoisted_32,
                          _createTextVNode(" " + _toDisplayString(_ctx.currentClickedTab.isActive) + " ", 1),
                          _hoisted_33,
                          _hoisted_34,
                          _hoisted_35,
                          _hoisted_36,
                          (_ctx.currentClickedTab.tabSimilarity)
                            ? (_openBlock(), _createBlock(_component_v_chip, {
                                key: 0,
                                color: $options.getColorCodeForSimilarityValue(_ctx.currentClickedTab.tabSimilarity),
                                variant: "outlined",
                                size: "small"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.currentClickedTab.tabSimilarity) + " ", 1),
                                  _createVNode(_component_v_tooltip, {
                                    activator: "parent",
                                    location: "end"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString($options.displayNameForClassification($options.getClassificationBasedOnSimilarityScore(_ctx.currentClickedTab.tabSimilarity))), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["color"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_v_col, { cols: "3" }, {
                        default: _withCtx(() => [
                          _hoisted_37,
                          _hoisted_38,
                          _createVNode(_component_v_textarea, {
                            class: "mx-4 my-2",
                            "data-testId": "tabtitle",
                            modelValue: _ctx.currentClickedTab.cleanTitleUpdated,
                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.currentClickedTab.cleanTitleUpdated) = $event)),
                            label: "Tab title",
                            onBlur: _cache[23] || (_cache[23] = ($event: any) => ($options.OnTabClassificationUpdated(_ctx.currentClickedTab)))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: "6" }, {
                        default: _withCtx(() => [
                          _hoisted_39,
                          _hoisted_40,
                          _createVNode(_component_v_textarea, {
                            class: "mx-4 my-2",
                            "data-testId": "tabContent",
                            modelValue: _ctx.currentClickedTab.contentUpdated,
                            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.currentClickedTab.contentUpdated) = $event)),
                            label: "Tab Content",
                            onBlur: _cache[25] || (_cache[25] = ($event: any) => ($options.OnTabClassificationUpdated(_ctx.currentClickedTab)))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1024),
                  _hoisted_41,
                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "3" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_select, {
                            items: _ctx.humanClassificationsList,
                            "item-title": "text",
                            "item-value": "value",
                            label: "Human Classification",
                            modelValue: _ctx.currentClickedTab.humanClassification,
                            "onUpdate:modelValue": [
                              _cache[26] || (_cache[26] = ($event: any) => ((_ctx.currentClickedTab.humanClassification) = $event)),
                              _cache[27] || (_cache[27] = ($event: any) => ($options.OnTabClassificationUpdated(_ctx.currentClickedTab)))
                            ],
                            variant: "underlined",
                            class: "mx-2 my-2"
                          }, null, 8, ["items", "modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: "3" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_select, {
                            items: _ctx.confidenceItems,
                            "item-title": "text",
                            "item-value": "value",
                            label: "Confidence",
                            modelValue: _ctx.currentClickedTab.confidence,
                            "onUpdate:modelValue": [
                              _cache[28] || (_cache[28] = ($event: any) => ((_ctx.currentClickedTab.confidence) = $event)),
                              _cache[29] || (_cache[29] = ($event: any) => ($options.OnTabClassificationUpdated(_ctx.currentClickedTab)))
                            ],
                            variant: "underlined",
                            class: "mx-2 my-2"
                          }, null, 8, ["items", "modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: "3" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            label: "Notes",
                            modelValue: _ctx.currentClickedTab.notes,
                            "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.currentClickedTab.notes) = $event)),
                            variant: "underlined",
                            "multi-line": "",
                            class: "capitalize mx-2 my-2",
                            onBlur: _cache[31] || (_cache[31] = ($event: any) => ($options.OnTabClassificationUpdated(_ctx.currentClickedTab)))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: "2" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            label: "Reviewer",
                            disabled: true,
                            modelValue: _ctx.currentClickedTab.reviewer,
                            "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.currentClickedTab.reviewer) = $event)),
                            variant: "underlined",
                            class: "capitalize mx-2 my-2"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_v_card_actions, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_btn, {
                    variant: "text",
                    onClick: ($event: any) => (isActive.value = false)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Close")
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["title"])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}